import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Steps } from 'antd'
import _ from 'lodash'
import { ProductionProgressContext } from '../../contexts'

const { Step } = Steps

const ItemProgressBar = ({ item }) => {
  const [productionProgress, setProductionProgress] = useState([])
  const [currentProgress, setCurrentProgress] = useState(null)

  const { productionProgresses } = useContext(ProductionProgressContext)

  useEffect(() => {
    if (!!item && !!productionProgresses) {
      setProductionProgress(
        productionProgresses.filter(progress => item.id === progress.item_id)
      )
    }
  }, [item, productionProgresses])

  useEffect(() => {
    const existProgresses = !!productionProgress && productionProgress.length > 0

    if (existProgresses) {
      const currentProgress = _.findIndex(productionProgress, ({ current }) => current)

      setCurrentProgress(currentProgress)
    }
  }, [productionProgress])

  return (
    <div className="ProductionProgress__ProgressBar">
      <Steps current={currentProgress}>
        {productionProgress.map(({ name }) => <Step title={name} key={name}/>)}
      </Steps>
    </div>
  )
}

ItemProgressBar.propTypes = {
  item: PropTypes.object
}

export default ItemProgressBar
